import React from 'react';
import { connect } from 'react-redux';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { verifyStock } from '~/actions/rawMaterial';
import Title from '~/components/Title';
import MultiPickerCount from '~/components/MultiPickerCount';
import RawMaterialPicker from '~/components/RawMaterialPicker';
import LocationPicker from '~/components/LocationPicker';
import ContainerPicker from '~/components/ContainerPicker';
import OrPicker from '~/components/OrPicker';
import Spinner from '~/components/Spinner';
import Tag from '~/components/Tag';

import styleDialog from '~/style/dialog.scss';
import style from './style.scss';

const LocationOrContainerPicker = OrPicker({
  location: LocationPicker,
  container: ContainerPicker,
});

const MultiRawMaterialPicker = MultiPickerCount(RawMaterialPicker);

class Dialog extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      result: false,
      diff: [],
      rawMaterialStock: [],
      location: null,
      locationDiff: null,
    };
  }

  submit() {
    this.setState({ loading: true });
    verifyStock(
      this.props.dispatch,
      this.context.apiClient,
      this.state.rawMaterials,
      this.state.location,
      this.state.locationDiff
    )
      .then((r) => this.setState({
        result: true,
        diff: Object.keys(r.data.diff).map((id) => ({
          id,
          count: r.data.diff[id],
        })),
        rawMaterialStock: r.data.rawMaterialStock,
        loading: false
      }));
  }

  render() {
    return (
      <div className={[styleDialog.background, style[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
        <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
          <IconButton className={styleDialog.closeButton} icon="close" onClick={() => this.context.dialogClose(this.props.dialogId)} />
          <div className={styleDialog.content}>
            {this.state.loading && <div style={{ display: 'flex', justifyContent: 'center' }}><Spinner /></div>}
            {!this.state.loading && !this.state.result && (
              <form onSubmit={e => { e.preventDefault(); this.submit(); }}>
                <Title style={{ marginBottom: '10px' }}>Verify Stock</Title>
                <div className={style.row}>
                  <div className={style.title}>Raw Material Goal</div>
                  <div className={style.field}>
                    <MultiRawMaterialPicker
                      value={this.state.rawMaterials}
                      onChange={rawMaterials => this.setState({ rawMaterials })}
                    />
                  </div>
                </div>
                <div className={style.row}>
                  <div className={style.title}>Location</div>
                  <div className={style.field}>
                    <LocationOrContainerPicker
                      value={this.state.location}
                      onChange={location => this.setState({ location })}
                    />
                  </div>
                </div>
                <div className={style.row}>
                  <div className={style.title}>LocationDiff</div>
                  <div className={style.field}>
                    <LocationOrContainerPicker
                      value={this.state.locationDiff}
                      onChange={locationDiff => this.setState({ locationDiff })}
                    />
                  </div>
                </div>
                <Button
                  style={{ marginTop: '10px' }}
                  primary
                  raised
                  label="Verify"
                  type="submit"
                />
              </form>
            )}
            {!this.state.loading && this.state.result && (
              <div>
                <Title style={{ marginTop: '10px' }}>Diff</Title>
                <div style={{ overflowY: 'auto', maxHeight: '300px', padding: '10px' }}>
                  {this.state.diff.sort((a, b) => (b.count - a.count)).map((item) => (
                    <div key={item.id} style={{ display: 'flex' }}>
                      <span style={{ flexGrow: 1 }}><Tag type="rawMaterial" id={item.id} /></span>
                      <span>{item.count}</span>
                    </div>
                  ))}
                </div>
                <Title style={{ marginTop: '10px' }}>Stock</Title>
                <div style={{ overflowY: 'auto', maxHeight: '300px', padding: '10px' }}>
                  {this.state.rawMaterialStock.sort((a, b) => (b.count - a.count))
                    .map((item, index) => (
                      <div key={item.rawMaterialId + index} style={{ display: 'flex' }}>
                        <span style={{ flexGrow: 1 }}><Tag type="rawMaterial" id={item.rawMaterialId} /></span>
                        <span>{item.count}</span>
                      </div>
                    ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(Dialog);



// WEBPACK FOOTER //
// ./app/dialogs/RawMaterialVerify/index.js